"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var MultiFilterButton_1 = require("./MultiFilterButton");
var SingleFilterButton_1 = require("./SingleFilterButton");
function filterable(config) {
    return {
        getInfo: function () { return ({ name: "filterable" }); },
        onInjectColumn: function (renderColumn) { return function (record, rowKey, recordIndex, column, columnIndex) {
            var columnResult = renderColumn(record, rowKey, recordIndex, column, columnIndex);
            // recordIndex > -1 是记录行，我们只注入表头
            if (recordIndex > -1) {
                return columnResult;
            }
            // 不是目标列
            if (column.key !== config.column) {
                return columnResult;
            }
            var children = columnResult.children;
            if (config.type === "single") {
                children = (react_1.default.createElement(SingleFilterButton_1.SingleFilterButton, tslib_1.__assign({}, config), children));
            }
            else if (config.type === "multiple") {
                children = (react_1.default.createElement(MultiFilterButton_1.MultipleFilterButton, tslib_1.__assign({}, config), children));
            }
            return tslib_1.__assign(tslib_1.__assign({}, columnResult), { children: children });
        }; },
    };
}
exports.filterable = filterable;
//# sourceMappingURL=filterable.js.map